import { useEffect, useState } from "react";
import GoogleApi from "../../api/GoogleApi";
import { toast } from "react-toastify";

function GoogleConnect() {

  const [loading, setLoading] = useState(true);

  const [connected, setConnected] = useState(false);

  const [email, setEmail] = useState("");

  useEffect(() => {
    loadStatus();
  }, []);
const loadStatus = async () => {
  try {
    const res = await GoogleApi.status();

    setConnected(res.connected);
    setEmail(res.email || "");
  } catch (err) {
    console.log(err);
  } finally {
    setLoading(false);
  }
};
const connectGoogle = async () => {

    const res = await GoogleApi.connect();

    const popup = window.open(
        res.url,
        "_blank",
        "width=700,height=700"
    );

    if (!popup) {
        toast.error("Please allow popup.");
        return;
    }

    const timer = setInterval(() => {

        if (popup.closed) {

            clearInterval(timer);

            loadStatus();

        }

    },1000);

};

  const disconnect = async () => {

    if (!window.confirm("Disconnect Google Account?")) {
      return;
    }

    await GoogleApi.disconnect();

    setConnected(false);

    setEmail("");

    toast.success("Disconnected");

  };

  if (loading) {

    return (

      <div className="page-wrapper">

        <div className="content">

          Loading...

        </div>

      </div>

    );

  }

  return (

<div className="page-wrapper">

<div className="content">

<div className="row justify-content-center">

<div className="col-lg-7">

<div className="card shadow">

<div className="card-header">

<h4>

Google Calendar Connection

</h4>

</div>

<div className="card-body">

{connected ? (

<>

<div className="text-center">

<i
className="ti ti-circle-check"
style={{
fontSize:70,
color:"#22c55e"
}}
/>

<h3 className="mt-3">

Google Connected

</h3>

<p>

{email}

</p>

<button
className="btn btn-danger mt-3"
onClick={disconnect}
>

Disconnect

</button>

</div>



</>

) : (

<>

<div className="text-center">

<i
className="ti ti-brand-google"
style={{
fontSize:70,
color:"#4285F4"
}}
/>

<h3 className="mt-3">

Connect Google Calendar

</h3>

{/* <p>

Google Calendar connect karne ke baad
system automatically Google Meet
generate karega.

</p> */}

<button

className="btn btn-primary"

onClick={connectGoogle}

>

Continue with Google

</button>

</div>

<p>

To create automatic Google Meet links you need to connect your Google account.

</p>

{/* <button

className="btn btn-primary"

onClick={connectGoogle}

>

Continue with Google

</button> */}

</>

)}

</div>

</div>

</div>

</div>

</div>

</div>

);

}

export default GoogleConnect;